// assets
import { IconMoneybag, IconChecklist } from '@tabler/icons';
import { createChildGroupMenuItem, createChildMenuItem, createMenuItem } from 'utils/menu';

// ==============================|| PAYMENT MENU ITEMS ||============================== //

const paymentItems = [
  createMenuItem('payment-list', 'pembayaran.read', 'Data Pembayaran', '/payment', IconMoneybag, false),
  createMenuItem('verifikasi-pembayaran', 'pembayaran.verifikasi.read', 'Verifikasi Pembayaran', '/verifikasi-pembayaran', IconChecklist, false)
];

const children = [
  {
    id: 'pembayaran-menu',
    // Parent muncul jika ada children yang visible (user punya salah satu permission)
    // perm bisa dikosongkan atau menggunakan salah satu permission yang user punya
    perm: 'pembayaran.read', // Fallback permission, tapi parent tetap muncul jika ada children yang visible
    title: 'Pembayaran',
    type: 'collapse',
    icon: IconMoneybag,
    children: createChildMenuItem(paymentItems)
  }
];

const pembayaran = {
  id: 'pembayaran',
  title: '',
  type: 'group',
  children: createChildGroupMenuItem(children)
};

export default pembayaran;
